// extracted by mini-css-extract-plugin
export var backdropBlur = "_e2-0";
export var contentCard = "_e2-5";
export var frame = "_e2-2";
export var image = "_e2-4";
export var imagePane = "_e2-3";
export var modal = "_e2-1";